











import { defineComponent, onBeforeMount, watch, ref, nextTick } from 'vue-demi';
import { i18n } from '../../i18n';
import NavTabs from './components/nav-tabs.vue';
import Title from './components/title.vue';
import Content from './components/content.vue';
import { useMall } from './hooks/use-mall';
import { useNavTab } from './hooks/use-nav-tab';
import { checkIsInVisibleWindow } from '../../utils/visble-window';
import { biClick } from '@tencent/fit-bi-sdk';

export default defineComponent({
  name: 'MallIndex',
  components: {
    NavTabs,
    Title,
    Content,
  },
  emit: ['initDone'],
  props: {
    title: {
      type: String,
      required: true,
    },
    autoSwitch: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const { isInited, isHasMallData, currMallInfo, init, setCurrSpid, setUserClicked } = useMall();
    const { mallTabList, setAutoSwitchNavTab, clearAutoSwitch, startAutoSwitch } = useNavTab(handleSwithNextTab);
    const container = ref<InstanceType<typeof HTMLElement> | null>(null);
    const navTab = ref<InstanceType<typeof NavTabs> | null>(null);

    onBeforeMount(() => {
      setAutoSwitchNavTab();
      init();
    });

    /**
     * 检测商圈展示区域是否在视窗中，只有在视窗中才会轮询切换分类
     * 分类自动切换展示逻辑：
     * 1、商圈70%出现在可视区会启动自动切换，否则会停止
     * 2、如果用户手动点击商圈区域，会停止自动切换
     */
    function listenVisibleWindowChange() {
      const el = container.value;
      if (el) {
        checkIsInVisibleWindow({
          el,
          visbleChanged: (isVisble) => {
            if (isVisble) startAutoSwitch();
            else clearAutoSwitch();
          },
        });
      }
    }
    watch(isInited, (val) => {
      if (val) {
        context.emit('initDone');
        nextTick(() => {
          listenVisibleWindowChange();
        });
      }
    });

    function handleNavChanged(spId: string) {
      setCurrSpid(spId);
      biClick('theme_mall.navtab_click', {
        fspid: spId,
      });
    }

    /**
     * 记录用户点击过商圈信息
     */
    function handleClick() {
      setUserClicked();
    }

    /** 券查询前通知，需要清除切换分类定时器 */
    function handleBeforeCompleted() {
      clearAutoSwitch();
    }

    /** 查询完毕后，重新启动定时切换分类功能 */
    function handleAfterCompleted() {
      startAutoSwitch();
    }

    function handleSwithNextTab(swtichId: string) {
      if (navTab.value) {
        navTab.value.switchTo(swtichId);
      }
    }

    return {
      i18n,
      navTab,
      container,
      isInited,
      isHasMallData,
      mallTabList,
      currMallInfo,
      handleClick,
      handleNavChanged,
      handleBeforeCompleted,
      handleAfterCompleted,
    };
  },
});
